import React, { Component } from 'react';
import './AddFriendCell.css';

import UserAvatar from './UserAvatar.js';

class AddFriendCell extends Component {
  constructor(props) {
    super(props);

    this.state = {
      added: false
    };
  }

  addFriend = () => {
    this.setState({ added: true });
    this.props.addFriend();
  }

  render() {
    const { user } = this.props;
    const { displayName, email, avatar } = user;

    const { added } = this.state;

    let addButton = <button onClick={this.addFriend} className="AddFriendCell__action"><img src="/assets/img/add-friend-button-plus.svg" alt=""/>Add</button>;

    if (added) {
      addButton = <button className="AddFriendCell__action" disabled={true}><img src="/assets/img/add-friend-button-check.svg" alt=""/>Pending</button>
    }

    return (
      <div className="AddFriendCell">
        <UserAvatar wrapperClassName="AddFriendCell__avatar-wrap" user={user} />

        <div className="AddFriendCell__content">
          <p className="AddFriendCell__name">{displayName}</p>
          <p className="AddFriendCell__label">{email}</p>
        </div>

        <div className="AddFriendCell__action-wrap">
          {addButton}
        </div>
      </div>
    );
  }
}

export default AddFriendCell;



// WEBPACK FOOTER //
// ./src/components/AddFriendCell.js